export default {
    meta: {
        title: '广告位详情',
        isShowNav: true,
        activeMenu: '/advertisement',
        crumbs: {
            path: ['/advertisement'],
            name: ['广告位管理'],
        },
    },
};
